module.exports = __webpack_public_path__ + "static/img/instagram.9be81fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.png
// module id = caPL
// module chunks = 0